import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { GalleryItem } from '../models/GalleryItem'
import { VENUES_URL } from '../utils/urls'

const fetchVenueGallery = (venueSlug: string, params: TableParams) =>
  SBAPI.FetchPaginated<GalleryItem[]>(
    `${VENUES_URL}/${venueSlug}/gallery`,
    params
  )

const createVenuePicture = (venueSlug: string, venueGallery: FormData) =>
  SBAPI.Post(`${VENUES_URL}/${venueSlug}/gallery`, venueGallery)

const deleteVenuePicture = (venueSlug: string, venuePicture: GalleryItem) =>
  SBAPI.Delete(`${VENUES_URL}/${venueSlug}/gallery/${venuePicture.id}`)

const reorderVenueGallery = (
  venueSlug: string,
  orderData: { id: number; order: number }[]
) =>
  SBAPI.Post(`${VENUES_URL}/${venueSlug}/gallery/reorder`, {
    order: orderData,
  })

const updateFeaturedVenuePicture = (
  venueSlug: string,
  venuePicture: GalleryItem
) =>
  SBAPI.Post(
    `${VENUES_URL}/${venueSlug}/featured-image/${venuePicture.id}`,
    venuePicture
  )

export {
  createVenuePicture,
  deleteVenuePicture,
  fetchVenueGallery,
  reorderVenueGallery,
  updateFeaturedVenuePicture,
}
